import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthUser } from '../models/auth';
import { Router } from '@angular/router';
import { ToastrService } from '../../shared/services/toastr-service';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http : HttpClient,
    private router : Router,
    private toastr : ToastrService,
    private  dbConnection : DatabaseConnection
  ){

  }

  saveCurrentUser(user : AuthUser){
    localStorage.setItem('currentUserSygma', JSON.stringify(user))
    localStorage.setItem('currentSygmaSite', user.site)
    localStorage.setItem('currentSygmaSiteColor', (user.site_color))
  }

  getCurrentUser() : AuthUser{
    return JSON.parse(localStorage.getItem('currentUserSygma')??'{}') as AuthUser
  }

  updateCurrentUser(user : AuthUser){
    this.removeCurrentUser()
    this.saveCurrentUser(user)
  }

  removeCurrentUser(){
    localStorage.removeItem('currentUserSygma')
  }

  isAuthentificated(){
    const expiration = new Date((this.getCurrentUser()?.token?.token_expiration)).getTime()

    if(isNaN(expiration))
      return false

    if(Date.now()>expiration)
      return false

    return true
  }


  login(data : Object){
    return this.http.post<AuthUser>(this.dbConnection.remoteApiConnection.value + 'login', data)
  }

  logout(){
    this.http.delete<AuthUser>(this.dbConnection.remoteApiConnection.value + 'logout').subscribe({
      next : (res) =>{
        this.removeCurrentUser()
        this.router.navigateByUrl("/login")
      },
      error : (err) =>{
        this.toastr.error("Une erreur est survenue")
      }
    })
  }

  activeAccount(data : Object){
    return this.http.post<boolean>(this.dbConnection.remoteApiConnection.value + 'active-account', data)
  }
}
